import { CompanySize, MarketingCompanySize } from 'lib/types/company';
import _ from 'lodash';

// Returns a CompanySize enum value given an integer representing the number of learners.
export const getCompanySizeFromLearnerCount = (
  learnerCount: number
): CompanySize => {
  if (!learnerCount || learnerCount <= 10) {
    return CompanySize.ONE_TO_TEN;
  } else if (learnerCount <= 50) {
    return CompanySize.ELEVEN_TO_FIFTY;
  } else if (learnerCount <= 250) {
    return CompanySize.FIFTY_ONE_TO_TWO_FIFTY;
  } else if (learnerCount <= 1000) {
    return CompanySize.TWO_FIFTY_ONE_TO_ONE_THOUSAND;
  } else {
    return CompanySize.ONE_THOUSAND_PLUS;
  }
};

export const getCanScheduleSalesCall = (companySize: CompanySize): boolean => {
  return !_.includes(
    [CompanySize.ONE_TO_TEN, CompanySize.ELEVEN_TO_FIFTY],
    companySize
  );
};

export const getMarketingCompanySize = (
  companySize: CompanySize
): MarketingCompanySize => {
  return {
    [CompanySize.ONE_TO_TEN]: MarketingCompanySize.ONE_TO_FORTY_NINE,
    [CompanySize.ELEVEN_TO_FIFTY]: MarketingCompanySize.ONE_TO_FORTY_NINE,
    [CompanySize.FIFTY_ONE_TO_TWO_FIFTY]:
      MarketingCompanySize.FIFTY_TO_NINETY_NINE,
    [CompanySize.TWO_FIFTY_ONE_TO_ONE_THOUSAND]:
      MarketingCompanySize.TWO_FIFTY_TO_FOUR_NINETY_NINE,
    [CompanySize.ONE_THOUSAND_PLUS]:
      MarketingCompanySize.ONE_THOUSAND_TO_FOUR_THOUSAND_NINE_HUNDRED_NINETY_NINE,
  }[companySize];
};
